import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appInputNumber]',
  standalone: false,
})
export class InputNumberDirective {
  constructor() {}

  @HostListener('keydown', ['$event'])
  checkIfNumber(event: KeyboardEvent): boolean {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete', 'Home', 'End'];

    // Permetti i tasti di controllo e navigazione
    if (allowedKeys.includes(event.key)) {
      return true;
    }

    // Consenti solo numeri e la virgola
    if (!/^[0-9,]$/.test(event.key)) {
      event.preventDefault();
      return false;
    }

    return true;
  }
}
